<template>
  <div>
    <table class="table">
      <thead>
        <tr>
          <th>
            Name
          </th>
          <th v-for="customer in all_customers" :key="customer.uuid" scope="col">
            {{ customer.name }} <span v-if="!customer.status" class="text-danger">(DISABLED)</span>
          </th>
        </tr>
      </thead>
      <tbody v-if="customersWithUsers && organisationUsers">
        <tr v-for="user in user_data" :key="user.uuid">
          <td>{{ user.name }}</td>
          <td v-for="customer in user.customers" :key="customer.uuid">
            <ss-checkbox :id="`customer-active-${user.name}-${customer.uuid}`"
                         v-model="customer.active"
                         @change="(checked) => updateUserCustomers(user, customer, checked)" />
          </td>
        </tr>
      </tbody>
      <tbody v-else>
        <tr>
          <td>No customers for this organisation.</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  props: {
    customersWithUsers: {
      type: Array,
      required: true,
    },
    organisationUsers: {
      type: Array,
      required: true,
    },
    organisationUuid: {
      type: String,
      required: false,
      default: null,
    },
  },
  data() {
    return {
      user_data: [],
      all_customers: [],
    };
  },
  beforeMount() {
    this.setupUserData();
  },
  methods: {
    setupUserData() {
      if (!this.customersWithUsers || !this.organisationUsers) {
        return;
      }

      const vm = this;
      const all_customers = [];
      const user_data = [];

      _.forEach(this.customersWithUsers, (customer) => {
        all_customers.push({
          name: customer.name,
          uuid: customer.uuid,
          active: false,
          status: customer.status,
        });
      });

      this.all_customers = all_customers;

      _.forEach(this.organisationUsers, (user) => {
        const data = {};
        data.name = user.name;
        data.email = user.email;
        data.uuid = user.uuid;
        // add a property for every available customer so we can track its state (remove reactivity)
        data.customers = JSON.parse(JSON.stringify(all_customers));

        // Find out what customers this user is active from
        const active_customers = vm.getUsersActiveCustomers(user.uuid);

        // Update the customers 'active' property for this user.
        _.forEach(data.customers, (customer) => {
          if (active_customers.includes(customer.uuid)) {
            customer.active = true;
          }
        });

        // Push a sanitised version of the user -> customer data for templating.
        user_data.push(data);
      });

      this.user_data = user_data;
    },
    // Call the backend to update the active customers for a user.
    updateUserCustomers(user, customer, state) {
      const active_customer_uuids = user.customers
        .filter(user_customer => user_customer.active)
        .map(active_customer => active_customer.uuid);

      if (active_customer_uuids.length < 1) {
        // Re-check the checkbox
        this.$nextTick(() => customer.active = true);
        toastr.error("User must be assigned to at least one customer");
      } else {
        axios.post(`/api/v1/user/${user.uuid}/update-customers`, {
          customer_uuids: active_customer_uuids,
          organisation_uuid: this.organisationUuid,
        }).then(() => {
          toastr.success("User Customers Updated");
        }).catch((error) => {
          // Revert the checkbox
          this.$nextTick(() => customer.active = !state);
          window.handleAxiosError(error);
        });
      }
    },

    // Determine which customers are selected for a user.
    getUsersActiveCustomers(user_uuid) {
      const active_customers = [];
      _.forEach(this.customersWithUsers, (customer) => {
        const customer_user_uuids = _.map(customer.users, 'uuid');
        const found = customer_user_uuids.includes(user_uuid);

        if (found) {
          active_customers.push(customer.uuid);
        }
      });

      return active_customers;
    },

    // Set the active value for a specific customer within a user.
    setCheckbox(user_uuid, customer_uuid, active = true) {
      // Find the target user within the user_data array.
      const user = _.find(this.user_data, user => user.uuid === user_uuid);

      // Find the target customer within the users customers.
      const customer = _.find(user.customers, customer => customer.uuid === customer_uuid);

      // Set the target customer within the user to active.
      customer.active = active;
    },
  },
};
</script>
